var entryTypes = {
  '1': 'Precert',
  '2': 'Cert',
  '3': 'CT-Qualified Cert',
}

var sigAlgs = {
  '1': 'RSA MD2',
  '2': 'RSA MD5',
  '3': 'RSA SHA-1',
  '4': 'RSA SHA-256',
  '5': 'RSA SHA-384',
  '6': 'RSA SHA-512',
  '7': 'DSA SHA-1',
  '8': 'DSA SHA-256',
  '9': 'ECDSA SHA-1',
  '10': 'ECDSA SHA-256',
  '11': 'ECDSA SHA-384',
  '12': 'ECDSA SHA-512',
  '13': 'PSS SHA-256',
  '14': 'PSS SHA-384',
  '15': 'PSS SHA-512',
}

var pubAlgs = {
  '1': 'RSA',
  '2': 'DSA',
  '3': 'ECDSA',
}

var valLevels = {
  '1': 'Domain',
  '2': 'Organization',
  '3': 'Extended',
}

function name(tag, names) {
  if (tag in names) {
    return names[tag]
  }
  return 'Other'
}

function add(obj, key, x) {
  if (key in obj) {
    obj[key] += x
  } else {
    obj[key] = x
  }
}

// itemize converts a map from bucket name -> count to a format that can be
// consumed by graph widgets. It pools any buckets that are too small to be
// visible into an Other bucket, if possible.
export function itemize(obj) {
  const threshold = 0.02, buckets = 7

  let data = [], total = 0
  for (let key in obj) {
    data.push({name: key, image: [key], count: obj[key]})
    total += obj[key]
  }

  let droppedKeys = [], droppedCount = 0
  data = data.filter(function(x) {
    if ((x.count/total) < threshold) {
      droppedKeys.push(x.name)
      droppedCount += x.count
      return false
    }
    return true
  })

  // Either add what was dropped to the standard Other bucket, or if there's
  // no Other bucket and we've filtered out >=2%, make a new Other bucket.
  let otherIdx = data.findIndex(function(x) { return x.name == 'Other' })
  if (otherIdx != -1) {
    data[otherIdx].image = data[otherIdx].image.concat(droppedKeys)
    data[otherIdx].count += droppedCount
  } else if ((droppedCount/total) >= threshold) {
    data.push({name: 'Other', image: droppedKeys, count: droppedCount})
    otherIdx = data.length-1
  } else {
    total -= droppedCount
  }

  // If there are more buckets than we have colors, take the smallest buckets
  // and pool them into the Other bucket.
  if (data.length >= buckets) {
    // Put the Other bucket at the end; sort the rest of the array normally,
    // ascending by count.
    data = data.sort(function(x, y) {
      if (x.name == 'Other') {
        return 1
      } else if (y.name == 'Other') {
        return -1
      }
      return x.count - y.count
    })

    if (otherIdx == -1) {
      data.push({name: 'Other', image: [], count: 0})
    }
    for (let i = 0; i < data.length-buckets; i++) {
      data[data.length-1].image = data[data.length-1].image.concat(data[i].image)
      data[data.length-1].count += data[i].count
    }
    data = data.slice(data.length - buckets)
  }

  // Sort the array in an aesthetically pleasing way, alphabetical with the
  // Other bucket at the end. Compute each bucket's percentage of the total.
  data = data.sort(function(x, y) {
    if (x.name == 'Other') {
      return 1
    } else if (y.name == 'Other') {
      return -1
    } else if (x.name < y.name) {
      return -1
    } else if (x.name > y.name) {
      return 1
    }
    return 0
  })
  for (let i = 0; i < data.length; i++) {
    data[i].percent = data[i].count / total
  }

  return data
}

export function parse(breakdown, filters) {
  let acc = {
    'entryType': {},
    'sigAlg':    {},
    'pubAlg':    {},
    'valLevel':  {},
    'rootName':  {},
    'expired':   {},
  }

  for (let key in breakdown) {
    let parts = key.split(':')

    let entryType = name(parts[0], entryTypes),
      sigAlg = name(parts[1], sigAlgs),
      pubAlg = name(parts[2], pubAlgs),
      valLevel = name(parts[3], valLevels),
      rootName = parts.slice(4).join(':')

    let skip = filters['entryType'] && !filters['entryType'].includes(entryType) ||
      filters['sigAlg'] && !filters['sigAlg'].includes(sigAlg) ||
      filters['pubAlg'] && !filters['pubAlg'].includes(pubAlg) ||
      filters['valLevel'] && !filters['valLevel'].includes(valLevel) ||
      filters['rootName'] && !filters['rootName'].includes(rootName)
    if (skip) {
      continue
    }

    let e = 0, u = 0
    if (!filters['expired'] || filters['expired'].includes('Expired')) {
      e = breakdown[key]['E']
    }
    if (!filters['expired'] || filters['expired'].includes('Current')) {
      u = breakdown[key]['U']
    }

    add(acc['entryType'], entryType, e+u)
    add(acc['sigAlg'], sigAlg, e+u)
    add(acc['pubAlg'], pubAlg, e+u)
    add(acc['valLevel'], valLevel, e+u)
    add(acc['rootName'], rootName, e+u)

    add(acc['expired'], 'Expired', e)
    add(acc['expired'], 'Current', u)
  }

  return {
    'entryType': itemize(acc['entryType']),
    'sigAlg':    itemize(acc['sigAlg']),
    'pubAlg':    itemize(acc['pubAlg']),
    'valLevel':  itemize(acc['valLevel']),
    'rootName':  itemize(acc['rootName']),
    'expired':   itemize(acc['expired']),
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/roll.js